import { ICheckbox } from "../../interfaces/Checkbox";
import { ButtonUnstyled } from "../button";
import styles from "./styles.module.scss";

export function CheckboxAtom(
  props: ICheckbox & { onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void }
) {
  const interactie = props.disabled
    ? () => {}
    : (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => props.onClick(event);

  const containerClassName = getContainerClassName(props.checked, props.disabled);
  const checkboxClassName = getCheckboxClassName(props.checked, props.disabled);

  return (
    <div className={containerClassName}>
      <ButtonUnstyled id={props.id} onClick={interactie}>
        <div title={props.label} className={checkboxClassName}>
          {props.checked && (
            <img alt="checked" className={styles.checked__image} src="/assets/icons/icon-checkbox-white.svg" />
          )}
        </div>

        {props.label && <span className={styles.checkbox__label}>{props.label}</span>}
      </ButtonUnstyled>
    </div>
  );
}

function getContainerClassName(checked: boolean, disabled?: boolean): string {
  let className = styles.checkbox__container;

  if (checked) className += ` ${styles["checkbox--checked"]}`;

  if (disabled) className += ` ${styles["checkbox--disabled"]}`;
  else if (!checked) className += ` ${styles["checkbox__container__hover"]}`;

  return className;
}

function getCheckboxClassName(checked: boolean, disabled?: boolean): string {
  let className = styles.checkbox;

  if (disabled) {
    className += ` ${styles["checkbox--disabled"]}`;
    className += checked ? ` ${styles["checkbox--gray"]}` : ` ${styles["checkbox--white"]}`;
    return className;
  }

  className += checked ? ` ${styles["checkbox--blue"]}` : ` ${styles["checkbox--white"]}`;

  return className;
}
